import { XIcon } from "@heroicons/react/solid";

const UnflagConfirmationModal = ({
  isOpen,
  onClose,
  onSubmit,
  loading = false,
  accountNumber,
  bankName
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="flex justify-between items-center p-4 border-b">
          <h3 className="text-lg font-bold uppercase text-gray-900">
            Unflag Account
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500"
            disabled={loading}
          >
            <XIcon className="h-6 w-6" />
          </button>
        </div>

        <div className="p-4">
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <p className="text-gray-700 mb-2">
                Are you sure you want to unflag this account?
              </p>
            </div>

            <div className="mb-4 bg-yellow-50 p-3 rounded-md">
              <div className="mb-2">
                <span className="font-medium">Account Number:</span> {accountNumber}
              </div>
              <div>
                <span className="font-medium">Bank Name:</span> {bankName}
              </div>
            </div>

            <div className="flex justify-end">
              <button
                type="button"
                onClick={onClose}
                disabled={loading}
                className="mr-3 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 disabled:opacity-50"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:opacity-50"
              >
                {loading ? "Processing..." : "Yes, Unflag Account"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UnflagConfirmationModal;